module.exports = __webpack_public_path__ + "img/hk_3.f86e19e0.png";